import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Paper, ListItem, ListItemText } from '@mui/material';
import { useCompany } from '../../stores';

const DeviceList = () => {
  const { t } = useTranslation();
  const companyStore = useCompany();
  const company = companyStore.data;

  if (!company) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        {t('companyScreen.devices')}
      </Typography>
      <Paper sx={{ marginTop: 2, marginBottom: 2, padding: '1rem' }}>
        {company.deviceList
          ? company.deviceList.map((device) => (
              <ListItem key={device.deviceId}>
                <ListItemText
                  primary={`${t('companyScreen.model')}: ${device.model}`}
                  secondary={`${t('companyScreen.deviceId')}: ${device.deviceId}`}
                />
              </ListItem>
            ))
          : null}
      </Paper>
    </Box>
  );
};

export default DeviceList;
